<template>
	<v-flex>
		<v-combobox
			v-if="!isSimple"
			ref="rawInput"
			v-model="selectedValue"
			:append-icon="''"
			:error-messages="$props.error"
			:items="options"
			:label="$props.label"
			:placeholder="' '"
			:readonly="readonly"
		></v-combobox>
		<v-combobox
			v-if="isSimple"
			ref="rawInput"
			v-model="selectedValue"
			:append-icon="''"
			:error-messages="$props.error"
			:items="options"
			:label="$props.label"
			:placeholder="' '"
			:readonly="readonly"
			class="simple"
			hide-details
		></v-combobox>
	</v-flex>
</template>

<script>
export default {
	name: "Autocomplete",
	props: ['readonly', 'value', 'ajax', 'data', 'label', 'simple', 'error'],
	data() {
		return {
			endpoint: '',
			selectedValue: null,
			options: [],
			ajaxLoaded: false
		}
	},
	computed: {
		isSimple() {
			return (typeof this.$props.simple !== 'undefined');
		}
	},
	watch: {
		value: function (newVal, oldVal) {
			if (newVal != oldVal) {
				if (newVal !== null) {
					if (this.selectedValue !== null) {
						if (this.selectedValue.value != newVal) {
							this.setValue(newVal);
						}
					} else {
						this.setValue(newVal);
					}
				} else {
					this.selectedValue = null;
				}
			}
		},
		selectedValue: function (val) {
			if (val !== null) {
				if (val !== this.$props.value) {
					this.$nextTick(() => {
						this.$emit('input', val);
					})
				}
			} else {
				this.$nextTick(() => {
					this.$emit('input', '');
				})
			}
		},
	},
	methods: {
		blurUpdate(e) {
			this.selectedValue = e.target.value;
		},
		setValue(newVal) {
			if (this.$props.ajax) {
				if (!this.ajaxLoaded) {
					var vm = this;
					this.$APICall('get', 'autocomplete/' + this.endpoint, [], function (data) {
						vm.options = data;
						vm.ajaxLoaded = true;
						vm.selectedValue = newVal;
					});
				} else {
					this.selectedValue = newVal;
				}
			} else {
				this.options = this.$props.data;
				this.selectedValue = newVal;
			}
		}
	},
	mounted() {
		if (this.$props.ajax) {
			this.endpoint = this.$props.data;
		}
		this.setValue(this.$props.value);
	}
}
</script>

<style scoped>
.simple {
	padding: 0px;
	margin: 0px;
}
</style>
